import { useContext } from 'react'
import { SchedulingDockContext } from './SchedulingDockContext'
import type { ContactJson } from 'app/types/entities'
import type { ScheduleEligibility } from 'app/types/scheduling'
import { getScheduleEligibility } from 'lib/scheduleEligibility'

/** Reads the location the provider already fetched, so cards share one request. */
export function useCanSchedule(contact: ContactJson): ScheduleEligibility {
  const { location } = useContext(SchedulingDockContext)
  return getScheduleEligibility(contact, location)
}
